document.addEventListener('DOMContentLoaded', ()=>{

    let comparisonElSwiper = new Swiper(".band__comparaison_media_xt.swiper", {
        slidesPerView: 1,
        navigation: {nextEl: ".band__comparaison_media_xt .swiper-button-next", prevEl: ".band__comparaison_media_xt .swiper-button-prev"}
    });    

    new Swiper(".bandcollapsible__content__swiper.swiper", {
         slidesPerView: 'auto',spaceBetween: 22,
         pagination: { el: ".bandcollapsible__content__swiper .swiper-pagination", clickable: true },
         navigation: { nextEl: ".bandcollapsible__content__swiper .swiper-button-next", prevEl: ".bandcollapsible__content__swiper .swiper-button-prev" }
    });

    new Swiper('.HH-FtbrandiconOUTr.swiper', { spaceBetween: 0, centeredSlides: true, speed: 6000, autoplay: { delay: 1, }, loop: true, slidesPerView:'auto', });

    new Swiper(".review-section-Mn .mySwiper", {
        slidesPerView: 1.2,spaceBetween: 7,
        navigation: {nextEl: ".review-section-Mn .swiper-button-next", prevEl: ".review-section-Mn .swiper-button-prev"},
        pagination: { el: ".review-section-Mn .swiper-pagination", clickable: true },
        breakpoints: {
            0: { slidesPerView: 1.1 },
            768: { slidesPerView: 1.2 },
            1024: { slidesPerView: 3.5 }
        }
    });

    new Swiper(".tabswith__detailswrapper_tabs_interior.swiper", {
      slidesPerView: 'auto',
      spaceBetween: 40,
      breakpoints: {
        750: { spaceBetween: 80 }
      }      
    }); 
  
    new Swiper(".tabswith__detailswrapper__tabs_briefly_sw.swiper", {
      slidesPerView: 'auto',
      spaceBetween: 22,
      navigation: { nextEl: ".tabswith__detailswrapper__tabs_briefly_sw .swiper-button-next", prevEl: ".tabswith__detailswrapper__tabs_briefly_sw .swiper-button-prev" }, 
      pagination: { el: ".tabswith__detailswrapper__tabs_briefly_sw .swiper-pagination",  clickable: true },
      breakpoints: {
        750: { pagination: { el: ".swiper-pagination",  type: "progressbar" } }
      }        
    }); 

    new Swiper(".bandProspecting__health__images.swiper", {
        slidesPerView: 'auto',spaceBetween: 18,
        navigation: {nextEl: ".bandProspecting__health__images .swiper-button-next", prevEl: ".bandProspecting__health__images .swiper-button-prev"},
        pagination: { el: ".bandProspecting__health__images .swiper-pagination", clickable: true },
        breakpoints: {
            750: { spaceBetween: 30 }      
        }  
    });    

    if( document.querySelectorAll('.bandcollapsible_ques').length > 0 ){
        document.querySelectorAll('.bandcollapsible_ques').forEach((el)=>{
            el.addEventListener('click', (target)=>{
                if( window.screen.width > 749 ){
                    target.preventDefault();
                    document.querySelectorAll('.bandcollapsible__collapsible_itemwp').forEach((elm)=>{elm.classList.remove('active') });
                    target.target.closest('.bandcollapsible__collapsible_itemwp').classList.toggle('active');
                }
            })
        })
    }

    document.querySelectorAll('[js-more-vw]').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
            target.preventDefault();
            let targettabName = target.target.closest('.bandProspecting__health_slide').querySelector('[js-more-vw]').dataset.index;
            document.querySelector(`.bandProspecting__health__popup[data-found-index="${targettabName}"]`).classList.add('active');
            document.body.classList.add('overflow-hidden');
        });
    });

    document.querySelectorAll('.bandProspecting__health_cross_icon').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
            target.preventDefault();
            document.querySelectorAll(`.bandProspecting__health__popup`).forEach((el)=>{el.classList.remove('active')});
            document.body.classList.remove('overflow-hidden');
        });
    });

    document.querySelectorAll('.bandProspecting__health__popupOvr').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
            target.preventDefault();
            document.querySelectorAll(`.bandProspecting__health__popup`).forEach((el)=>{el.classList.remove('active')});
            document.body.classList.remove('overflow-hidden');
        });
    });    

    document.querySelectorAll('.swp__slide_tabs_interior').forEach((el)=>{
        el.addEventListener('click', (target)=>{
            target.preventDefault();
            let TabName = target.target.closest('.swp__slide_tabs').dataset.tabName;
            document.querySelectorAll('.swp__slide_tabs_interior').forEach((elm)=>{ elm.classList.remove('active') });
            document.querySelectorAll('.tabs_slider__main__contentwrapper').forEach((elm)=>{ elm.classList.remove('active') });
            target.target.closest('.swp__slide_tabs').querySelector('.swp__slide_tabs_interior').classList.add('active');
            document.querySelector(`.tabs_slider__main__contentwrapper[data-tab-content="${TabName}"]`).classList.add('active');
        })
    })  

    document.querySelectorAll('.bandHIWBgBox').forEach(function(element) {
      element.addEventListener('click', function() {
        document.querySelector('.Hume-popup-overlay').classList.add('active');
        document.body.classList.add('overflow-hidden');
        if( window.screen.width > 749 ){
          let popupVd = document.querySelector('.Hume-popup-overlay').querySelector('.video-container.desktop-box').querySelectorAll('video');
          popupVd.forEach((vd)=>{
            if (vd.paused) { vd.play() }
          })
        }else{
          let popupVdMb = document.querySelector('.Hume-popup-overlay').querySelector('.video-container.mobile-box').querySelectorAll('video');
          popupVdMb.forEach((vd)=>{
            if (vd.paused) { vd.play() }
          })          
        }
      });
    });
    document.querySelectorAll('.Hume-popup-close').forEach(function(element) {
      element.addEventListener('click', function(event) {
        event.stopPropagation();
        document.querySelector('.Hume-popup-overlay').classList.remove('active');
        document.body.classList.remove('overflow-hidden');
        let popupVdC = document.querySelector('.Hume-popup-overlay').querySelectorAll('video');
        popupVdC.forEach((vd)=>{
          if (!vd.paused) { vd.pause() } 
        })        
      });
    });    

    document.querySelectorAll('.band__comparaison_accordion_name').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
            target.preventDefault();
            let targetCurrentTb = target.target.closest('.band__comparaison_accordion_tab').querySelector('.band__comparaison_accordion_name').dataset.tabCp;
            if( target.target.closest('.band__comparaison_accordion_tab').classList.contains('active') ){
                target.target.closest('.band__comparaison_accordion_tab').classList.remove('active');
                target.target.closest('.band__comparaison_accordion_tab').querySelector('.band__comparaison_accordion_content').style.maxHeight = null;
            }else{
                document.querySelectorAll('.band__comparaison_accordion_tab').forEach((elm)=>{ elm.classList.remove('active'); elm.querySelector('.band__comparaison_accordion_content').style.maxHeight = null; });
                target.target.closest('.band__comparaison_accordion_tab').classList.add('active');
                let mainTabContent = target.target.closest('.band__comparaison_accordion_tab').querySelector('.band__comparaison_accordion_content');
                mainTabContent.style.maxHeight = `${mainTabContent.scrollHeight}px`;            
            }
            setTimeout(()=>{
                window.scrollTo({
                top: document.querySelector('.band__comparaison_content_lyt').offsetTop - 158,
                behavior: 'smooth'
                });  
                comparisonElSwiper.slideTo(targetCurrentTb, 10, !0);           
            },100)
        })
    })  
   
    function isInViewportStickyElement(elem) { 
        var bounding = elem.getBoundingClientRect();
        var myElementHeight = elem.offsetHeight;
        var myElementWidth = elem.offsetWidth;
        return (bounding.top >= -myElementHeight && bounding.left >= -myElementWidth && bounding.right <= (window.innerWidth || document.documentElement.clientWidth) + myElementWidth && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) + myElementHeight) ; 
    }; 
    
    var recommendationElementTest = document.querySelectorAll('.mapwithouttest');
    window.addEventListener('scroll', ()=>{
        recommendationElementTest.forEach( (evt)=>{
        if ( isInViewportStickyElement(evt) ) {
            document.querySelectorAll(".withoutabteststk").forEach((target)=>{
            target.classList.add('hidden');
            });
        }else{
            document.querySelectorAll(".withoutabteststk").forEach((target)=>{
            target.classList.remove('hidden');
            });
        }
        })
    })
    
    const videoWrapper = document.querySelector('.bandHowItWorksMn, .WillNotShowOnBodyPodPDMN');
    const scrollingBar = document.querySelector('.ListScrollingBarWp');
    const announcementBar = document.querySelector('#shopify-section-announcement-bar');

    function handleScroll() {
        const scrollPosition = window.scrollY;
        if (videoWrapper) {
        const showBuyBarPosition = videoWrapper.offsetTop;
        if (scrollPosition > showBuyBarPosition) {
            scrollingBar.classList.add('active');
            document.body.classList.add('HiddenHeaderBar');
        } else {
            scrollingBar.classList.remove('active');
            document.body.classList.remove('HiddenHeaderBar');
        }
        }
        const announcementBarHeight = announcementBar.offsetHeight;
        scrollingBar.style.top = `${announcementBarHeight}px`;
    }
    window.addEventListener('scroll', handleScroll);    

    var quantity = document.querySelector('.quantity-control-button.add'); if(quantity){ quantity.addEventListener('click', function(e){ e.preventDefault(); var inputElement  = this.closest('.number-input-control').querySelector('.input-text'); var inputValue = parseInt(inputElement.value) || 0; inputElement.value = inputValue + 1; }) }
    var minusQuantity = document.querySelector('.quantity-control-button.subtract'); if(minusQuantity){ minusQuantity.addEventListener('click', function(e){ e.preventDefault(); var inputElement  = this.closest('.number-input-control').querySelector('.input-text'); var inputValue = parseInt(inputElement.value) || 0; if (inputValue > 1) { inputElement.value = inputValue - 1; }})}    
    var popupContentWrapper = document.querySelectorAll(".hsa-fsa-popup-content-wrapper"); if(popupContentWrapper.length){ popupContentWrapper.forEach(function(popup){ popup.addEventListener("click", function() { document.body.classList.add("hsa-popup-open"); document.querySelector(".hsapopupContainer").classList.add("active-open"); }); }) }
    var closeButtn = document.querySelector('.hsapopupContainer .hsaCrsBtn'); if(closeButtn){ closeButtn.addEventListener('click', function() { document.body.classList.remove('hsa-popup-open'); document.querySelector('.hsapopupContainer').classList.remove('active-open'); }); }
    document.addEventListener('click', function(event) {
        var targetElement = event.target.closest('.Wphyopyiomshy');
        if (targetElement) { 
            event.preventDefault();
            targetElement.classList.add('active');
            var siblings = targetElement.parentNode.querySelectorAll('.Wphyopyiomshy');
            siblings.forEach(function(sibling) {
            if (sibling !== targetElement) {
                sibling.classList.remove('active'); 
            } 
            });
        } 
    });   
    
    var oncliickpopup= document.querySelectorAll('.Wphyopyiomshy');
    if(oncliickpopup.length > 0){ 
        oncliickpopup.forEach((el)=>{
            el.addEventListener('click', function (evt) {
                evt.preventDefault();
                if( evt.target.closest('.Wphyopyiomshy').classList.contains('OnlyAvailThat')){
                    document.querySelector('.OneClick_Popup').classList.remove('show-checked');
                }else{
                    document.querySelector('.OneClick_Popup').classList.add('show-checked');
                }
             })
        })
    }

    document.querySelector('.OneClick_Popup').addEventListener('click', function(evt){
    evt.preventDefault();
    if (!this.classList.contains('show-checked')) {
        let thisElm = this;
        thisElm.classList.add('clickedMe');
        var mainID = this.getAttribute('main-productid'); var mnpQy = document.querySelector('[title="Qty"]').value; var formData = new FormData(); 
        formData.append('quantity', mnpQy); formData.append('id', mainID); fetch('/cart/add.js', { method: 'POST', body: formData }) 
        .then(response => { if (!response.ok) { throw new Error('Network response was not ok'); } return response.json(); }) 
        .then(data => {
        thisElm.classList.remove('clickedMe');
        window.location.href = '/checkout'; 
        }) 
    }else if(this.classList.contains('WarrantyDisabledPopup')){
        let thisElm = this;
        thisElm.classList.add('clickedMe');
        var mainID = this.getAttribute('data-without-popup'); var mnpQy = document.querySelector('[title="Qty"]').value; var formData = new FormData(); 
        formData.append('quantity', mnpQy); formData.append('id', mainID); fetch('/cart/add.js', { method: 'POST', body: formData }) 
        .then(response => { if (!response.ok) { throw new Error('Network response was not ok'); } return response.json(); }) 
        .then(data => {
        thisElm.classList.remove('clickedMe');
        window.location.href = '/checkout'; 
        })      
    }else{
        document.querySelector('.Product_Popup').classList.add('popup-open'); document.body.classList.add('popup-show');
    }
    })

    document.querySelectorAll('.accordianjshandle').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
            target.preventDefault();
            target.target.closest('.custom-faqs-Items').classList.toggle('active');
        });
    });  

    let ScrollTargetPDP = document.querySelectorAll(".ScrollerPdpAtc, .Dsrgyu, .Humeband-block-button, [js-scroll-to-destination]");
    ScrollTargetPDP.forEach((evt)=>{
        evt.addEventListener('click', (target)=>{
            target.preventDefault();
            if(window.innerWidth > 769){
            var targetElement = document.querySelector('.MainProductRightPortionWp');
            window.scrollTo({
                top: targetElement.offsetTop - document.querySelector('#shopify-section-announcement-bar').clientHeight,
                behavior: 'smooth'
            });
            }else{
            var targetElement = document.querySelector('.WarrantyProtectionWp');
            window.scrollTo({
                top: targetElement.offsetTop - 120,
                behavior: 'smooth'
            });
            }  
        })
    });

    document.querySelectorAll('.wpunijtysh').forEach((elm)=>{
    elm.addEventListener('click', (target)=>{
        target.preventDefault();
        if( target.currentTarget.classList.contains('TargetToDivElement') ){
        var targetElement = document.querySelector('.WidgetreviewsLoader');
        if ( window.screen.width > 769) {
            window.scrollTo({
            top: targetElement.offsetTop - 158,
            behavior: 'smooth'
            });    
        }else{
            window.scrollTo({
            top: targetElement.offsetTop,
            behavior: 'smooth'
            });           
        }        
        }else{
        target.target.closest('.Tabinityiniopsmkm').classList.toggle('active');
        }
    });
    });     
    
  document.querySelectorAll('.Tilemnexh').forEach((elm)=>{
    elm.addEventListener('click', (target)=>{
      target.preventDefault();
      target.target.closest('.CollpsmnTabex').classList.toggle('active');
    });
  });

})
